import type { PlataformaPwa } from '@/modules/events/acerto';

/**
 * O iPadOS 13+ se identifica como Mac no user agent; a tela de toque é o que o separa de um Mac de
 * verdade, que não tem toque.
 */
export function detectarPlataformaPwa(): PlataformaPwa {
  const { userAgent, maxTouchPoints } = navigator;
  if (/iPad|iPhone|iPod/.test(userAgent)) return 'ios';
  if (/Macintosh/.test(userAgent) && maxTouchPoints > 1) return 'ios';
  if (/Android/i.test(userAgent)) return 'android';
  return 'desktop';
}
